module.exports = __webpack_public_path__ + "static/media/form-lab-number.bf8c9c38.svg";